import React, { useEffect, useRef, useState } from 'react';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { useQuery } from 'react-query';
import { useReactToPrint } from 'react-to-print';
import Loader from '../../../Shared/Loader';

const SupplierDueReport = () => {
    const [suppliers, setSuppliers] = useState([]);
    const [searchResult, setSearchResult] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const componentRef = useRef()

    const generatePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle: `Supplier Due Report`,

    });

    useEffect(() => {
        const url = `https://servers.thakurgaonexpress.com/rupkotha/supplierduereport`
        fetch(url)
            .then(res => res.json())
            .then(data => {
                const filtered = data?.supplierDues.filter(due => due.balance !== 0)
                setSuppliers(filtered);
                console.log(data?.supplierDues);
                setIsLoading(false)
            })
    }, []);


    if (isLoading) {
        return <Loader></Loader>
    }

    const handleSearchResult = (event) => {
        const searchText = event.target.value;
        const match = suppliers.filter(supplier => supplier.name.includes(searchText) || supplier.name.toLowerCase().includes(searchText)
            || supplier.name.toUpperCase().includes(searchText));
        setSearchResult(match);
        setIsSearching(true);
    }

    const totalBalance = isSearching ? searchResult.reduce((total, currentValue) => total + parseFloat(currentValue.balance), 0) :
        suppliers.reduce((total, currentValue) => total + parseFloat(currentValue.balance), 0);

    return (
        <div className='mx-2'>
            <h2 className='mt-8 text-center text-2xl font-bold'>Suppliers Due Report</h2>
            <div className='text-right mt-12'>
                <ReactHtmlTableToExcel
                    id="test-table-xls-button"
                    className="btn btn-error text-white btn-xs mt-2 lg:mt-0"
                    table="table-to-xls"
                    filename={`Balance Sheet`}
                    sheet={`balance-sheet`}
                    buttonText="Export to exel" />
                <button className='btn btn-success btn-xs ml-2 text-white' onClick={generatePrint}>Print</button>
            </div>
            <div className='flex lg:justify-end justify-center items-center mt-4'>
                <div class="form-control w-60">
                    <input onChange={handleSearchResult} type="text" placeholder="Search Supplier" class="input text-xs input-bordered bg-white input-error w-full max-w-xs" />
                </div>
            </div>
            <div ref={componentRef} class="overflow-x-auto">
                <table id='table-to-xls' class="table w-1/2 mx-auto text-xs mb-20">
                    <caption className='text-center text-lg mb-2 mt-16'>Suppliers Due Report</caption>
                    <thead>
                        <tr className='text-center'>
                            <th className='bg-primary text-white normal-case'>SL</th>
                            <th className='bg-primary text-white normal-case'>Supplier Code </th>
                            <th className='bg-primary text-white normal-case'>Supplier Name</th>
                            <th className='bg-primary text-white normal-case'>Address</th>
                            <th className='bg-primary text-white normal-case'>Phone</th>
                            <th className='bg-primary text-white normal-case'>Opening Balance</th>
                            <th className='bg-primary text-white normal-case'>Total Purchase</th>
                            <th className='bg-primary text-white normal-case'>Total Purchase Return</th>
                            <th className='bg-primary text-white normal-case'>Total Payment</th>
                            <th className='bg-primary text-white normal-case'>Balance</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            isSearching ? searchResult.map((supplier, index) => <tr className='text-center'>
                                <td>{index + 1}</td>
                                <td>{supplier?.supplierCode}</td>
                                <td>{supplier?.name}</td>
                                <td>{supplier?.address}</td>
                                <td>{supplier?.phone}</td>
                                <td className='text-blue-800'>{supplier?.opening}</td>
                                <td className='text-green-600'>{supplier?.totalPurchase}</td>
                                <td className='text-green-600'>{supplier?.totalPurchaseReturn}</td>
                                <td className='text-yellow-700'>{supplier?.totalPayment}</td>
                                <td className='text-primary font-bold'>{supplier?.balance}</td>
                            </tr>) : suppliers.map((supplier, index) => <tr className='text-center'>
                                <td>{index + 1}</td>
                                <td>{supplier?.supplierCode}</td>
                                <td>{supplier?.name}</td>
                                <td>{supplier?.address}</td>
                                <td>{supplier?.phone}</td>
                                <td className='text-blue-800'>{supplier?.opening}</td>
                                <td className='text-green-600'>{supplier?.totalPurchase}</td>
                                <td className='text-green-600'>{supplier?.totalPurchaseReturn}</td>
                                <td className='text-yellow-700'>{supplier?.totalPayment}</td>
                                <td className='text-primary font-bold'>{supplier?.balance}</td>
                            </tr>)
                        }
                    </tbody>
                    <tfoot>
                        <tr>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'></th>
                            <th className='bg-primary text-white normal-case'>Total Dues</th>
                            <th className='bg-primary text-white normal-case'>{totalBalance}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
};

export default SupplierDueReport;